/* AW26 universe countdown — display-only ticking clock to a target ISO datetime.
   At zero it swaps the clock for the "expired" message (does not unlock anything). */
(function () {
  function pad(n) { return String(n).padStart(2, "0"); }
  function init(el) {
    var iso = el.getAttribute("data-target");
    if (!iso) return;
    var target = new Date(iso).getTime();
    var days = el.querySelector('[data-cd="days"]'),
        hrs  = el.querySelector('[data-cd="hrs"]'),
        min  = el.querySelector('[data-cd="min"]'),
        sec  = el.querySelector('[data-cd="sec"]');
    if (!days || isNaN(target)) return;
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        days.textContent = "00"; hrs.textContent = "00"; min.textContent = "00"; sec.textContent = "00";
        el.setAttribute("data-live", "1");
        clearInterval(timer);
        return;
      }
      var s = Math.floor(diff / 1000);
      days.textContent = pad(Math.floor(s / 86400));
      hrs.textContent  = pad(Math.floor((s % 86400) / 3600));
      min.textContent  = pad(Math.floor((s % 3600) / 60));
      sec.textContent  = pad(s % 60);
    }
    tick();
    var timer = setInterval(tick, 1000);
  }
  function boot() {
    document.querySelectorAll("[data-aw26-countdown]").forEach(init);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else { boot(); }
})();
